import Inputmask from "inputmask";
import { useEffect, useRef, useState } from "react";
import useEffectMemo from "src/hooks/useEffectMemo";

interface UseInputMaskOptions {
  mask: Inputmask.Options["mask"];
  register?(element: HTMLElement): void;
  options?: Inputmask.Options;
  onChange?: (event: InputEvent) => void;
}

const useInputMask = ({ mask, register, options, onChange }: UseInputMaskOptions) => {
  const ref = useRef<HTMLInputElement>(null);
  const inputmask = useRef<Inputmask.Instance>(null);

  const [, setMaskInput] = useState<Inputmask.Instance | null>(null);

  useEffectMemo(() => {
    if (!ref.current) {
      return;
    }

    inputmask.current = Inputmask({
      mask,
      ...options,
    });
    inputmask.current.mask(ref.current);

    // Set an otherwise unused state value to trigger a re-render when the input
    // mask options change. Otherwise the options might not come into effect
    setMaskInput(inputmask.current);
  }, [mask, options]);

  useEffect(() => {
    if (register && ref.current) {
      register(ref.current);
    }
  }, [register]);

  return ref;
};

export default useInputMask;
